"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayer = exports.Root = exports.ImageHolderPlay = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _reactPlayer = _interopRequireDefault(require("react-player"));
var _constants = require("../../constants");
var _constants2 = require("../DetailItem/constants");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  gridColumn: '1 / 2',
  gridRow: '1 / 2',
  display: 'grid',
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: _constants.LARGE_COMPONENT_RADIUS,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '50% 50%',
  backgroundSize: 'cover',
  [theme.breakpoints.between('sm', 'lg')]: {
    maxWidth: _constants2.DETAIL_ITEM_MOBILE_MAX_WIDTH,
    maxHeight: _constants2.DETAIL_ITEM_MOBILE_MAX_HEIGHT
  },
  [theme.breakpoints.up('lg')]: {
    borderRadius: `${_constants.LARGE_COMPONENT_RADIUS} 0 0 ${_constants.LARGE_COMPONENT_RADIUS}`
  }
}));
const VideoPlayer = exports.VideoPlayer = (0, _mui.styled)(_reactPlayer.default)(({
  theme
}) => ({
  display: 'block',
  gridArea: '1 / 1 / 2 / 2',
  justifySelf: 'stretch',
  alignSelf: 'stretch',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: `${_constants.LARGE_COMPONENT_RADIUS} ${_constants.LARGE_COMPONENT_RADIUS} 0 0`,
  [theme.breakpoints.up('lg')]: {
    borderRadius: `${_constants.LARGE_COMPONENT_RADIUS} 0 0 ${_constants.LARGE_COMPONENT_RADIUS}`
  }
}));
const ImageHolderPlay = exports.ImageHolderPlay = (0, _mui.styled)(_presentationComponents.PlayIcon)({
  position: 'absolute',
  zIndex: 1,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
});
